import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Summary extends Component {
  static propTypes = {
    fdata: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      regionList: {
        af: 'Africa',
        as: 'Asia',
        eu: 'Europe',
        me: 'Middle East',
        na: 'North America',
        oc: 'Ocenia',
        sa: 'South America'
      }
    };
  }

  render() {
    const { fdata } = this.props;
    return (
      <div className='ui raised segment'>
        <div className='ui large horizontal list'>
          {fdata.region_code !== 'None' && (
            <div className='item'>
              <div className='ui large blue label'>
                Region
                <div className='detail'>
                  {this.state.regionList[fdata.region_code.toLowerCase()]}
                </div>
              </div>
            </div>
          )}
          {fdata.culture_area !== 'None' && (
            <div className='item'>
              <div className='ui large blue label'>
                Culture Area
                <div className='detail'>{fdata.culture_area}</div>
              </div>
            </div>
          )}
          {fdata.countries !== 'None' && (
            <div className='item'>
              <div className='ui large blue label'>
                Country
                <div className='detail'>{fdata.countries}</div>
              </div>
            </div>
          )}
          {fdata.lang_name !== 'None' && (
            <div className='item'>
              <div className='ui large blue label'>
                Language
                <div className='detail'>
                  {fdata.lang_name}{' '}
                  {fdata.lang_code !== 'None' && `(${fdata.lang_code})`}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
